module.exports = __webpack_public_path__ + "img/asuka_gijutsu.39bb2daf.jpg";